import BunkeyAPI from '../api/BunkeyAPI'
import {
  PUBLIC_TOKEN,
  PUBLIC_TOKEN_SUCCESS,
  PUBLIC_TOKEN_FAILURE
} from '../constants/public-types'

export const publicToken = () => {
  return dispatch => {
    dispatch({ type: PUBLIC_TOKEN })
    BunkeyAPI({
      url: `/security/token`,
      method: 'GET',
    }).then(resp => {
      dispatch({ type: PUBLIC_TOKEN_SUCCESS, payload: resp.data.token })
    }).catch(err => {
      dispatch({ type: PUBLIC_TOKEN_FAILURE, payload: 'none' })
    })
  }
}